import { Box } from '@zillow/constellation-10';
import { ModalType } from '../../types/ModalType';
import useModal from '../../hooks/useModal';
import { secondaryColumnStyles } from './styles';

type Props = {
  children: React.ReactNode;
  shouldHideOnMobile: boolean;
};

export default function SecondaryColumn({ children, shouldHideOnMobile }: Props) {
  const { setActiveModal } = useModal();
  const handleDragEnter = () => {
    setActiveModal(ModalType.AttachmentsUploader);
  };

  return (
    <Box
      css={{
        ...secondaryColumnStyles,
        display: shouldHideOnMobile ? { base: 'none', xxl: 'flex' } : 'flex',
      }}
      onDragEnter={handleDragEnter}
    >
      {children}
    </Box>
  );
}
